/**
 * Location status values
 */
export enum LocationStatusEnum {
	/**
	 * Location is open
	 */
	OPEN = 'open',
	/**
	 * Location is closed
	 */
	CLOSED = 'closed',
}
